"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fitModes = {
  contain: true,
  cover: true,
  fill: true,
  none: true,
  'scale-down': true
};

exports.isFit = function (value) {
  return value in fitModes;
};